import { OPERATION_TYPES } from '@/utils/constants/portfolioConstants';

export function isBuyOperation(
  operationType: string | null | undefined
): boolean {
  return operationType === OPERATION_TYPES.BUY;
}

export function isSellOperation(
  operationType: string | null | undefined
): boolean {
  return operationType === OPERATION_TYPES.SELL;
}

export function getOperationCashAmount(operation: {
  operationType: string | null | undefined;
  operationCashAmount: number;
}): number {
  return isBuyOperation(operation.operationType)
    ? -1 * operation.operationCashAmount
    : operation.operationCashAmount;
}

// If the operation is an order, return its creationDate, otherwise return operation[dateField].
export function getOperationDate(
  operation: { isOrder?: boolean; creationDate?: string | null } & Record<
    string,
    unknown
  >,
  dateField: string
) {
  return operation.isOrder ? operation.creationDate : operation[dateField];
}
